export const isEmail = (email: string, isRequired: boolean): boolean => {
  if (email === undefined || email.trim() === "") return !isRequired;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const isValidPLZ = (plz: string, isRequired: boolean): boolean => {
  if (plz === undefined || plz.trim() === "") return !isRequired;
  const regex = /^[0-9]{5}$/;
  return regex.test(plz);
};

export const isNotEmpty = (
  input: string | boolean | undefined,
  isRequired: boolean
): boolean => {
  if (input === undefined) return !isRequired;

  if (typeof input === "string") {
    return input.trim() !== "";
  }
  if (typeof input === "boolean") {
    return true;
  }
  return false;
};

export const isValidTime = (time: string, isRequired: boolean): boolean => {
  if (time === undefined || time.trim() === "") return !isRequired;
  const regex = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
  return regex.test(time);
};

export const isDigitsOnly = (input: string, isRequired: boolean): boolean => {
  if (input === undefined || input.trim() === "") return !isRequired;
  const regex = /^\d+$/;
  return regex.test(input);
};

export function validateDate(dateString: string): boolean {
  const parts = dateString.split(".");
  if (parts.length !== 3) return false;

  const [day, month, year] = parts.map(Number);
  // Basic format validation
  if (!day || !month || !year) return false;

  // Create date object
  const date = new Date(year, month - 1, day);

  // Check if JS normalized it (e.g., 32.01.2024 -> 01.02.2024 would be invalid)
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return date < today; // must be before today
}

export function checkIfDateValid(dateString: string): boolean {
  const parts = dateString.split(".");
  if (parts.length !== 3) return false;

  const [day, month, year] = parts.map(Number);
  if (!day || !month || !year) return false;

  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}
